import { Component } from '@angular/core';
import { openClose } from '@core/animations/animations';
import { LttViewModel } from './ltt.view-model';
import { TestHooks } from './ltt.hooks';

@Component({
	selector: 'app-ltt',
	templateUrl: './ltt.component.html',
	styleUrls: ['ltt.component.scss'],
	animations: [openClose()],
	providers: [LttViewModel],
	standalone: false,
})
export class LttComponent {
	testHooks = TestHooks;

	constructor(public vm: LttViewModel) {}
}
